import PropTypes from 'prop-types'
import React from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import Bodymovin from 'components/bodymovin/bodymovin'
import styles from './wheel_loading.scss'

import loading from 'animations/loading'

const WheelLoading = props => (
	<Bodymovin animationData={loading} loop={true}>
		<div styleName={classNames({
			wrapper: true,
			light: props.theme === 'light',
			dark: props.theme === 'dark',
		})}>
		</div>
	</Bodymovin>
)

WheelLoading.propTypes = {
	theme: PropTypes.string,
}

WheelLoading.defaultProps = {
	theme: 'light',
}

export default CSSModules(WheelLoading, styles, {allowMultiple: true})
